import React from "react";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";

const Header = () => {
  return (
    <header>
      <Container>
        <Typography variant="h1">Web Development</Typography>
        <Typography variant="h3">
          <span role="img" aria-label="star">
            🌟
          </span>
          Super Stars
          <span role="img" aria-label="star">
            🌟
          </span>
        </Typography>
      </Container>
    </header>
  );
};

export default Header;
